import type { PrescriptionBrandingResponse, PrescriptionPageSize } from './types';

const PRESET_DIMENSIONS: Record<Exclude<PrescriptionPageSize, 'Custom'>, readonly [number, number]> = {
  A4: [210, 297],
  A5: [148, 210],
  Letter: [216, 279],
};

export function resolvePrescriptionPageDimensions(
  branding: PrescriptionBrandingResponse | undefined,
  pageSize: PrescriptionPageSize = branding?.pageSize ?? 'A4'
) {
  if (pageSize === 'Custom') {
    return {
      widthMm: branding?.customPageWidthMm ?? branding?.pageWidthMm ?? 210,
      heightMm: branding?.customPageHeightMm ?? branding?.pageHeightMm ?? 297,
    };
  }
  const [widthMm, heightMm] = PRESET_DIMENSIONS[pageSize];
  return { widthMm, heightMm };
}

export function configurePrescriptionPrintPage(
  widthMm: number,
  heightMm: number,
  margins: { topMm: number; rightMm: number; bottomMm: number; leftMm: number }
) {
  const id = 'doccareplus-prescription-page-size';
  let style = document.getElementById(id) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement('style');
    style.id = id;
    document.head.append(style);
  }
  style.textContent =
    `@page { size: ${widthMm}mm ${heightMm}mm; ` +
    `margin: ${margins.topMm}mm ${margins.rightMm}mm ${margins.bottomMm}mm ${margins.leftMm}mm; }`;
  document.documentElement.style.setProperty('--rx-page-width', `${widthMm}mm`);
  document.documentElement.style.setProperty('--rx-page-height', `${heightMm}mm`);
  document.documentElement.style.setProperty('--rx-margin-top', `${margins.topMm}mm`);
  document.documentElement.style.setProperty('--rx-margin-right', `${margins.rightMm}mm`);
  document.documentElement.style.setProperty('--rx-margin-bottom', `${margins.bottomMm}mm`);
  document.documentElement.style.setProperty('--rx-margin-left', `${margins.leftMm}mm`);
}
